<ion-content id="main-content" class="full-width-page">
    <div class="bg-theme-alt">
        <div class="bg-grad-special">
            <div class="bg-grad-special-alt">
                <div class="nk-ovm shape-u shape-contain shape-left-top"></div>
                <app-header></app-header>
                <section class="section bg-theme tc-light animated fadeInUp" data-animate="fadeInUp" data-delay="0.4"
                    style="visibility: visible; animation-delay: 0.4s;">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/ecosystem.png" alt="ecosystem">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Protecting CPAs from
                                            Quantum-Driven Data Integrity Risks</h6>
                                        <p>
                                            To provide accounting services CPAs must have confidence in the integrity of
                                            their client’s information systems that produce the data that they will work
                                            with to provide those services. The quantum decryption event that is coming
                                            raises integrity issues for all their clients threatening to put CPAs out of
                                            business if they cannot find some means of addressing integrity concerns and
                                            the potential professional liability exposures, they will create for them
                                            and their business clients. Transitioning business clients or their clients’
                                            customers to any of the NIST quantum resistant encryption alternatives
                                            postpones these integrity issues and sets them up for potential professional
                                            liability disasters that our technologies would help them avoid.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Breaking Free from the $189
                                            Billion Quantum Encryption Trap</h6>
                                        <p>
                                            Everyone is in the same boat leaving the encryption quantum computers will
                                            destroy and NIST estimates that will cost the US $189 billion. When clients
                                            start deciding between the different NIST alternatives and our technologies
                                            their choices will result in different financial consequences based on when
                                            each of these NIST alternatives start to fail. When these NIST alternatives
                                            fail exposing everyone’s data the resulting financial damage to CPA business
                                            clients and their customers will inspire lawyers to initiate professional
                                            liability claims against the CPAs liability insurance carriers. It won’t
                                            matter if the CPA recommended the failed alternative or not, their errors
                                            and omission policy covers them if they picked the wrong one or if they
                                            failed to suggest the right choice which would be our technologies that
                                            cannot fail. Then add the costs to transition to our permanent protections
                                            or one of the remaining NIST alternatives until it fails, maintains a place
                                            on that endless cycle of encryption failure that sends them to the next NIST
                                            alternative to fail.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/services.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/secured-transaction.png"
                                        alt="Secured Transaction">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Building a Secure and Profitable
                                            Future for CPAs and Their Clients</h6>
                                        <p>
                                            What the CPAs that work with us will recommend is for their business clients
                                            and their customers to avoid the costly endless cycle of encryption failure
                                            and choose our technologies that will make and or save them money, time, and
                                            effort. NIST is saying that to transition from asymmetric encryption to any
                                            of the NIST quantum resistant alternatives might cost $189 billion and then
                                            it will cost us something again when each of the NIST alternatives fail in
                                            the future. We expect the costs of fully implementing our technologies will
                                            be offset by the financial benefits of sharing our marketplace commissions
                                            with our buyers, sellers, the CPAs working with us and the third-party
                                            software developers building secure versions of META, Google, Tik Tok and
                                            similar popular internet programming.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Redefining the $552 Billion
                                            Digital Economy with Secure Profit Sharing</h6>
                                        <p>
                                            US marketing and advertising in 2024 was $552 billion and we plan on
                                            charging each industry what they traditionally spend and then give back 40%
                                            for our buyers and sellers to share, 10% to reward the CPAs helping us make
                                            these business relationships work and 10% to third party software developers
                                            for providing secure versions of the internet’s most popular programs that
                                            conform to our buyer’s data ownership and control policies. Whatever the
                                            cost to our CPAs, their business clients, and their clients’ customers these
                                            benefits plus the permanent security of our tech should more than cover any
                                            one-time transition costs in a few years.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6" style="display: flex;justify-content: center;">
                                    <img src="./assets/images/custom-hiddin/layout.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/binary-data.png" alt="gfx">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">From Counting Profits to Creating
                                            Them: A New Era for CPAs</h6>
                                        <p>
                                            Providing clients in phase I with market research, marketing campaigns,
                                            advertising delivery services, and related analytics that our tech makes
                                            possible, gives our CPAs new service revenues. Services that help their
                                            clients to make money rather than just being a necessary cost of doing
                                            business by counting the money their clients made on their own.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Turning Cybersecurity into Shared
                                            Prosperity for Businesses and Customers</h6>
                                        <p>
                                            Business clients in phase I get help making money from their CPA, permanent
                                            protections, avoid cyber liabilities, protect their customers, and share 40%
                                            of their traditional marketing spend with their customers that rewards them
                                            both.
                                        </p>
                                        <p>
                                            The customers of these business clients get permanent protections, avoid
                                            economic damage and related lawsuit expenses, enjoy their part of the 40%
                                            savings and get to share these benefits with those they want to securely
                                            communicate and do business with in the future.
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <img src="./assets/images/custom-hiddin/connect.png" alt="gfx">
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section class="section bg-theme tc-light">
                    <div class="container">
                        <div class="nk-block nk-block-features-s2">
                            <div class="row align-items-center gutter-vr-30px">
                                <div class="col-md-6">
                                    <img class="height450" src="./assets/images/custom-hiddin/shield.png" alt="gfx">
                                </div>
                                <div class="col-md-6">
                                    <div class="nk-block-text">
                                        <h6 class="title title-xs title-s1 tc-primary">Why CPAs Must Champion the Shift
                                            from Temporary Encryption to Permanent Security</h6>
                                        <p>
                                            CPAs need to help us explain to their business clients why everyone must
                                            transition from today’s encryption, and they can site the NIST July 5th
                                            announcement to prove the US government is behind everyone changing. Then
                                            they need to explain how replacing what makes their data valuable to others
                                            with our technology’s once used token is a permanent solution compared to
                                            any of the NIST quantum resistant temporary fixes. Explaining the faster our
                                            clients and their customers make this transition the less of a target their
                                            old, unprotected data becomes until reprocessed and the faster they will
                                            start making and or saving money, time, and effort with our technologies.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <app-footer></app-footer>
            </div>
        </div>
    </div>
</ion-content>